import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { GapBox } from 'components/Box'
import { SectionHeader } from 'components/Header'
import { TextLink } from 'components/Link'
import Paper from 'components/Paper'
import { useAbility } from 'providers/casl'
import { useCreateConnection } from '../../hooks/useCreateConnection'
import { ConnectionStatus } from './components/ConnectionStatus'
import { KNOWLEDGE_BASE } from './constants'
import { ConnectionStatusSectionProps } from './types'

export const ConnectionStatusSection = ({
  connection,
}: ConnectionStatusSectionProps): React.JSX.Element => {
  const ability = useAbility()
  const { t: tC } = useTranslation('common')
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'googleAdManagerConnection',
  })

  const { create, loading } = useCreateConnection()

  const createDisabled =
    loading ||
    (connection && connection.status !== 'failed') ||
    ability.cannot('update', 'GlobalSetupFeature-googleAdManagerConnection-connect')

  return (
    <Paper data-cy='connection-status-section'>
      <SectionHeader
        subtitle={t('connectionStatus.header.description')}
        subtitleEndAdornment={
          <TextLink
            link={{
              title: tC('learnMore'),
              url: KNOWLEDGE_BASE,
            }}
          />
        }
        title={t('connectionStatus.header.title')}
      />

      <GapBox />

      {connection && <ConnectionStatus {...connection} />}

      <Button
        disabled={createDisabled}
        onClick={create}
        variant='contained'
      >
        {t('connectionStatus.button')}
      </Button>
    </Paper>
  )
}
